
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {Level2GetFilterResponse} from './Level2GetFilterResponse';

/**
 * Level2GetFilterRequest struct
 */
class Level2GetFilterRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!Set=} symbolIds
   * @param {!Set=} symbolNames
   * @param {!number=} level
   * @constructor
   */
  constructor (parent = new Request(), symbolIds = new Set(), symbolNames = new Set(), level = 0) {
    super()
    super.copy(parent)
    this.SymbolIds = symbolIds
    this.SymbolNames = symbolNames
    this.Level = level
  }

  /**
   * Copy struct (shallow copy)
   * @this {!Level2GetFilterRequest}
   * @param {!Level2GetFilterRequest} other Other struct
   * @returns {!Level2GetFilterRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.SymbolIds != null) {
      this.SymbolIds = new Set()
      for (let item of other.SymbolIds) {
        if (item != null) {
          let tempItem
          tempItem = new UUID(item)
          this.SymbolIds.add(tempItem)
        } else {
          this.SymbolIds.add(null)
        }
      }
    } else {
      this.SymbolIds = null
    }
    if (other.SymbolNames != null) {
      this.SymbolNames = new Set()
      for (let item of other.SymbolNames) {
        if (item != null) {
          let tempItem
          tempItem = item
          this.SymbolNames.add(tempItem)
        } else {
          this.SymbolNames.add(null)
        }
      }
    } else {
      this.SymbolNames = null
    }
    if (other.Level != null) {
      this.Level = other.Level
    } else {
      this.Level = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!Level2GetFilterRequest}
   * @returns {!Level2GetFilterRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new Level2GetFilterRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new Level2GetFilterRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!Level2GetFilterRequest}
   * @param {!Level2GetFilterRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof Level2GetFilterRequest)) {
      throw new TypeError('Instance of Level2GetFilterRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!Level2GetFilterRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      SymbolIds: ((this.SymbolIds != null) ? Array.from(this.SymbolIds, item => ((item != null) ? item.toString() : null)) : null),
      SymbolNames: ((this.SymbolNames != null) ? Array.from(this.SymbolNames, item => ((item != null) ? item : null)) : null),
      Level: ((this.Level != null) ? this.Level : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return Level2GetFilterRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!Level2GetFilterRequest} other Object value
   * @returns {!Level2GetFilterRequest} Created struct
   */
  static fromObject (other) {
    return new Level2GetFilterRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!Level2GetFilterRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return Level2GetFilterRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!Level2GetFilterRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 2032
  }
}

export { Level2GetFilterRequest };

/**
 * Fast Binary Encoding Level2GetFilterRequest field model
 */
class FieldModelLevel2GetFilterRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.SymbolIds = new fbe.FieldModelSet(new fbe.FieldModelUUID(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.SymbolNames = new fbe.FieldModelSet(new fbe.FieldModelString(buffer, this.SymbolIds.fbeOffset + this.SymbolIds.fbeSize), buffer, this.SymbolIds.fbeOffset + this.SymbolIds.fbeSize)
    this.Level = new fbe.FieldModelUInt16(buffer, this.SymbolNames.fbeOffset + this.SymbolNames.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelLevel2GetFilterRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelLevel2GetFilterRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelLevel2GetFilterRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.SymbolIds.fbeSize + this.SymbolNames.fbeSize + this.Level.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelLevel2GetFilterRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.SymbolIds.fbeExtra + this.SymbolNames.fbeExtra + this.Level.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelLevel2GetFilterRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelLevel2GetFilterRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelLevel2GetFilterRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 2032
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelLevel2GetFilterRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelLevel2GetFilterRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SymbolIds.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SymbolIds.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolIds.fbeSize

    if ((fbeCurrentSize + this.SymbolNames.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SymbolNames.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolNames.fbeSize

    if ((fbeCurrentSize + this.Level.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Level.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Level.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelLevel2GetFilterRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelLevel2GetFilterRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelLevel2GetFilterRequest}
   * @param {!Level2GetFilterRequest} fbeValue Default value, defaults is new Level2GetFilterRequest()
   * @returns {!Level2GetFilterRequest} Level2GetFilterRequest value
   */
  get (fbeValue = new Level2GetFilterRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelLevel2GetFilterRequest}
   * @param {!Level2GetFilterRequest} fbeValue Level2GetFilterRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SymbolIds.fbeSize) <= fbeStructSize) {
      this.SymbolIds.get(fbeValue.SymbolIds)
    } else {
      fbeValue.SymbolIds.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolIds.fbeSize

    if ((fbeCurrentSize + this.SymbolNames.fbeSize) <= fbeStructSize) {
      this.SymbolNames.get(fbeValue.SymbolNames)
    } else {
      fbeValue.SymbolNames.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolNames.fbeSize

    if ((fbeCurrentSize + this.Level.fbeSize) <= fbeStructSize) {
      fbeValue.Level = this.Level.get(0)
    } else {
      fbeValue.Level = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Level.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelLevel2GetFilterRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelLevel2GetFilterRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelLevel2GetFilterRequest}
   * @param {!Level2GetFilterRequest} fbeValue Level2GetFilterRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelLevel2GetFilterRequest}
   * @param {Level2GetFilterRequest} fbeValue Level2GetFilterRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.SymbolIds.set(fbeValue.SymbolIds)
    this.SymbolNames.set(fbeValue.SymbolNames)
    this.Level.set(fbeValue.Level)
  }
}

export { FieldModelLevel2GetFilterRequest };

/**
 * Fast Binary Encoding Level2GetFilterRequest model
 */
class Level2GetFilterRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelLevel2GetFilterRequest(this.buffer, 4)
  }

  /**
   * Get the Level2GetFilterRequest model
   * @this {!Level2GetFilterRequestModel}
   * @returns {!FieldModelLevel2GetFilterRequest} model Level2GetFilterRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!Level2GetFilterRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!Level2GetFilterRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return Level2GetFilterRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!Level2GetFilterRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelLevel2GetFilterRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!Level2GetFilterRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!Level2GetFilterRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!Level2GetFilterRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!Level2GetFilterRequestModel}
   * @param {!Level2GetFilterRequest} value Level2GetFilterRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!Level2GetFilterRequestModel}
   * @param {!Level2GetFilterRequest} value Level2GetFilterRequest value, defaults is new Level2GetFilterRequest()
   * @return {!object} Deserialized Level2GetFilterRequest value and its size
   */
  deserialize (value = new Level2GetFilterRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new Level2GetFilterRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new Level2GetFilterRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!Level2GetFilterRequestModel}
   * @param {!number} prev Previous Level2GetFilterRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { Level2GetFilterRequestModel };
Level2GetFilterRequest.__has_response = true;
Level2GetFilterRequest.__response_class = Level2GetFilterResponse;
